import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Icon } from 'components'
import cn from 'classnames'
import './index.scss'
interface NavButtonProps {
    className?: string,
    to?: string,
    icon?: string,
    text?: string,
    disabled?: boolean,
    handleClick?: () => {}
}

export const NavButton = ({ className, to, icon, text, disabled = false, handleClick }: NavButtonProps) => {

    const { pathname } = useLocation();

    const classes = cn('flex flex-row items-center rounded duration-300 cursor-pointer p-3 hover:bg-white/[.04] text-grey-text', { 'bg-white/10 !text-white': to ? (pathname === to) : false, disabled }, className);

    return (
        to ?
            <Link to={to} className={classes}>
                {!!icon && 
                    <Icon name={icon} disabled={pathname !== to} />
                }
                <span className="ml-3 text-sm">{text}</span>
            </Link>
            :
            <div className={classes} onClick={handleClick}>
                {!!icon && 
                    <Icon name={icon} />
                }
                <span className="ml-3 text-sm">{text}</span>
            </div>

    )
}